import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Link from '../Link';

import s from './Button.css';

class Button extends React.Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    primary: PropTypes.bool,
    link: PropTypes.bool,
    yes: PropTypes.bool,
    no: PropTypes.bool,
  };

  static defaultProps = {
    onClick: null,
    primary: false,
    link: false,
    yes: false,
    no: false,
  };

  render() {
    const { primary, link, yes, no, to, children, ...props } = this.props;
    return (
      <Link
        to={to}
        className={cx(
          s.button,
          primary ? s.primary : false,
          link ? s.link : false,
          yes ? s.yes : false,
          no ? s.no : false,
        )}
        {...props}
      >
        {children}
      </Link>
    );
  }
}

export default withStyles(s)(Button);



// WEBPACK FOOTER //
// ./src/components/Button/Button.js